import {useGetToken} from 'components/hooks';
import {Loading} from 'components/grid-dx/loading/loading';
import authFetch from 'helpers/requests';
import React, {useEffect, useRef, useState} from 'react';
import FilterList from './FilterList';

const InstanceManagement = ({location}: any) => {
  const token = useGetToken();
  const [courseType, setCourseType] = useState('');
  const ids = useRef(location.state.key);

  useEffect(() => {
    authFetch(
      `/api/CourseType/GetCourseType?idCourse=${ids.current.iD_Course}`,
      {mode: 'cors'},
      token,
    )
      .then((response: any) => response.text())
      .then((data: any) => {
        setCourseType(data);
      })
      .catch((e: any) => {
        console.log(e);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (courseType === '') {
    return <Loading />;
  } else {
    return (
      <FilterList
        courseType={courseType}
        ids={ids.current}
        role={location.state.roles}
      />
    );
  }
};

export default InstanceManagement;
